<template>
  <div class="content">
    <h1>下单权益</h1>
    <p v-if="equity" class="promotion">
      {{ equity }}
    </p>
    <form class="w rs-form">
      <div class="rs-form--row">
        <label>您所在的城市</label>
        <div class="rlt" @click="go2CityList">
          <input
            type="text"
            readonly
            name="cityName"
            :value="
              cityInfo &&
              cityInfo.cityName &&
              cityInfo.cityName.replace('市', '')
            "
          />
          <i class="icon-arrow--right"></i>
        </div>
      </div>
      <div class="rs-form--row">
        <label for="tel">
          <span>您的手机号</span>
        </label>
        <input
          v-model="mobile"
          oninput="if(value.length > 11) value = value.slice(0,11)"
          maxlength="11"
          autocomplete="false"
          name="tel"
          placeholder="请填写您的手机号"
        />
      </div>
      <p class="tip">门店育儿顾问将通过手机号尽快与您进行联系</p>
      <slot name="button">
        <button type="submit" class="rs-form--submit" @click="submit">
          <span style="flex: 1">预约面试</span>
        </button>
      </slot>
    </form>
    <MockRouterAction title-from="月嫂主页" title-to="城市选择" ref="mra">
      <CityList
        :cityCode="cityInfo.cityId"
        @citySelected="citySelected"
      ></CityList>
    </MockRouterAction>
  </div>
</template>

<script>
// import { sendYuesaoConfigure } from '@/service/api/ys'
import CityList from '@/components/cityList/index.vue'
import MockRouterAction from '@/components/mockRouterAction/index.vue'
import { Toast } from 'vant'
import fetch from '@/plugins/fetch'
import qs from 'query-string'
export default {
  components: {
    MockRouterAction,
    CityList
  },
  props: {
    cityInfo: {
      type: Object,
      default: () => {
        return {
          cityId: '320100',
          cityName: '南京'
        }
      }
    },
    equity: {
      type: String,
      default: ''
    }
  },
  data() {
    let prePhone = this.$$cookie('phone')
    if (prePhone && prePhone.length >= 11) {
      prePhone = `${prePhone.substring(0, 3)}****${prePhone.substring(7)}`
    }
    return {
      mobile: prePhone,
      prePhone
    }
  },
  methods: {
    reScroll(e) {
      e && e.target && e.target.scrollIntoView()
    },
    go2CityList() {
      this.$router.push({
        query: {
          ...this.$route.query,
          routerAction: ''
        }
      })
      this.$refs.mra.show()
    },
    citySelected(data) {
      this.$router.go(-1)
      this.$emit('citySelected', data)
    },
    async submit(e) {
      e && e.preventDefault()
      let mobile = this.mobile
      //用户没有修改 默认登陆手机号
      if (this.prePhone === this.mobile) {
        mobile = this.$$cookie('phone')
      }
      if (!this.cityInfo) {
        Toast('请选择您的城市')
        return
      }
      if (!mobile) {
        Toast('请输入您的手机号')
        return
      }
      if (!/^[1][0-9]{10}$/.test(mobile)) {
        Toast('请输入正确手机号')
        return
      }
      this.$$newTrackClick({
        bizType: '180',
        pageLevelId: '121012508',
        clickId: '200008',
        pageParam: {
          fuid: this.$$cookie('uid')
        },
        positionParam: {
          fuid: this.$$cookie('uid')
        }
      })
      Toast.loading({ duration: 0, className: 'toast' })
      try {
        const content = {
          cityId: `${this.cityInfo.cityId}#${this.cityInfo.cityName}`,
          mobile
        }
        //生产是7 测试44
        const data = {
          setId: 7,
          content: JSON.stringify(content),
          mobile: content.mobile || '', //根据接口要求 外层加个mobile
          uid: this.$$cookie('uid') || ''
        }
        const result = await fetch(
          '//svsactivity.cekid.com/svshd-web/appclue/pushWishDetail.do',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: qs.stringify(data),
            credentials: 'include'
          }
        )
        const _res = await result.json()
        Toast.clear()
        if (_res && +_res.code === 1) {
          this.$emit('submitSuccess') // HOME组件关闭弹框
          Toast({
            message: '预约成功，请您保持电话畅通\n我们正在安排月嫂跟您沟通哦',
            className: 'custom-toast',
            icon: 'https://hzwimspic-1251601690.image.myqcloud.com/a7a0de50-6ee4-11ed-bd3c-13ebd47f6822_size_72x72'
          })
        } else {
          Toast((_res && _res.msg) || '很抱歉，系统出问题了~')
        }
      } catch (error) {
        Toast((e && e.msg) || '很抱歉，系统出问题了~')
      }
    }
  }
}
</script>

<style lang="scss">
.custom-toast {
  width: 4.48rem !important;
  font-size: 0.28rem !important;
  padding: 0.32rem 0.2rem !important;
}
</style>

<style lang="scss" scoped>
@import '@/assets/css/mixin';
h1 {
  color: #121212;
  font-weight: 500;
  margin-top: rem(36px);
  margin-bottom: rem(28px);
  font-size: rem(32px);
  text-align: center;
}
.promotion {
  border-radius: rem(20px);
  margin: 0 rem(30px);
  background: #fff9e4;
  color: #de701d;
  text-align: left;
  font-size: rem(24px);
  padding: rem(16px) rem(24px);
}
</style>
<style lang="scss" scoped src="./style.scss"></style>
